import { render, staticRenderFns } from "./main-form.vue?vue&type=template&id=9dca9c54&scoped=true&"
import script from "./main-form.vue?vue&type=script&lang=js&"
export * from "./main-form.vue?vue&type=script&lang=js&"
import style0 from "./main-form.vue?vue&type=style&index=0&id=9dca9c54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dca9c54",
  null
  
)

export default component.exports